import React from 'react';
import { useTheme } from 'styled-components';
import { GridProps, GridItemProps, GridItemBreakpoint } from './Grid.type';
import * as Styled from './Grid.styled';
import { SpacingValue } from 'styled-system';

const getGridItemBreakpoints = (
  xs?: GridItemBreakpoint,
  sm?: GridItemBreakpoint,
  md?: GridItemBreakpoint,
  lg: GridItemBreakpoint = 4,
) => ({
  xs: xs || sm || md || lg,
  sm: sm || md || lg,
  md: md || lg,
  lg: lg,
});

const getGridSpacingsBreakpoints = (
  xs?: SpacingValue,
  sm?: SpacingValue,
  md?: SpacingValue,
  lg: SpacingValue = 'S0',
) => ({
  xs: xs || sm || md || lg,
  sm: sm || md || lg,
  md: md || lg,
  lg: lg,
});

const Grid = ({
  columns = 12,
  columnSpacing,
  rowSpacing,
  alignItems,
  justifyContent,
  direction,
  wrap,
  children,
}: GridProps) => {
  const theme = useTheme();
  const childrenWithProps = React.Children.map(children, (child) =>
    React.isValidElement(child)
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        React.cloneElement<any>(child, { gridColumns: columns })
      : child,
  );
  return (
    <Styled.Grid
      columns={columns}
      columnSpacing={{
        ...getGridSpacingsBreakpoints(
          columnSpacing?.xs,
          columnSpacing?.sm,
          columnSpacing?.md,
          columnSpacing?.lg,
        ),
      }}
      rowSpacing={{
        ...getGridSpacingsBreakpoints(
          rowSpacing?.xs,
          rowSpacing?.sm,
          rowSpacing?.md,
          rowSpacing?.lg,
        ),
      }}
      alignItems={alignItems}
      direction={direction}
      wrap={wrap}
      justifyContent={justifyContent}
      theme={theme}
    >
      {childrenWithProps}
    </Styled.Grid>
  );
};

const GridItem = (props: GridItemProps) => {
  const { order, xs, md, sm, lg, children, gridColumns = 12, ...rest } = props;
  const theme = useTheme();
  return (
    <Styled.GridItem
      {...getGridItemBreakpoints(xs, sm, md, lg)}
      order={order}
      gridColumns={gridColumns}
      theme={theme}
      {...rest}
    >
      {children}
    </Styled.GridItem>
  );
};

export { Grid, GridItem };
